<div class="semi-circle-container">
  <div class="gauge-container">
    <div class="score-gauge">
      <svg class="gauge-svg" viewBox="0 0 200 120" preserveAspectRatio="xMidYMin meet">
        <defs>
          <linearGradient id="gaugeUnderGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stop-color="#ffffff" stop-opacity="0.7" />
            <stop offset="40%" stop-color="#e3f2fd" stop-opacity="0.6" />
            <stop offset="100%" stop-color="#90caf9" stop-opacity="0.4" />
          </linearGradient>
        </defs>
        <path
          class="gauge-under-fill"
          d="M 20 100 A 80 80 0 0 1 180 100 L 20 100 Z"
          fill="url(#gaugeUnderGradient)"
        />
        <!-- Background arc (unfilled portion) - full semi-circle -->
        <path
          class="gauge-background"
          d="M 20 100 A 80 80 0 0 1 180 100"
          fill="none"
          stroke="#e0e0e0"
          stroke-width="12"
          stroke-linecap="round"
        />
        <!-- Filled arc (progress) - overlaps the background -->
        <path
          class="gauge-progress"
          [attr.d]="getArcPath(gaugePercentage)"
          fill="none"
          [attr.stroke]="getScoreColor()"
          stroke-width="12"
          stroke-linecap="round"
          style="z-index: 2;"
        />
      </svg>
    </div>
  </div>
</div>